<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app color="#EFEFEA">
      <v-list :color="headerColor" class="px-0 py-1" dense>
        <v-list-item>
          <v-list-item-avatar>
            <WifipassIcon />
          </v-list-item-avatar>
          <v-list-item-content class="black--text text-h6">
            Wifipass
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense class="main-menu pt-0">
        <v-list-item link :to="{ name: 'portails' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$portails</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Portails</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'groupes' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$groupes</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Groupes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'nas' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$nas</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>NAS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isAdmin()" link :to="{ name: 'partenaires' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$partenaire</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Partenaires</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin()" link :to="{ name: 'modeles-portails' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$portal_model</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Modèles de portail</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin()" link :to="{ name: 'transactions-cb' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$cb_transaction</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Transactions CB</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin()" link :to="{ name: 'transactions-pms' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$pms</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Transactions PMS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="isAdmin()"
          link
          :to="{ name: 'authentifications-mac' }"
        >
          <v-list-item-icon>
            <v-icon class="fill-default">$mac</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Authentification MAC</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin()" link :to="{ name: 'card-editions' }">
          <v-list-item-icon>
            <v-icon class="fill-default">$edition</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Edition de cartes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-list dense>
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ username }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-alpha-v-box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ appVersion }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="exit">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Déconnexion</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-navigation-drawer>
    <v-app-bar app flat class="black--text inherit-color">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        v-if="isMobile"
      ></v-app-bar-nav-icon>
      <span class="text-h6">
        <v-icon left large v-if="!isMobile">{{ titleIcon }}</v-icon> {{ title }}
      </span>
      <v-spacer></v-spacer>
      <global-search-bar />
      <template v-slot:extension v-if="global.appTabs.length > 0">
        <custom-tabs
          :tabs="global.appTabs"
          :disabled="global.tabsDisabled"
        ></custom-tabs>
      </template>
    </v-app-bar>
    <v-divider></v-divider>
    <v-main>
      <v-container fluid class="full-height">
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>
    <v-snackbar :value="snackBar" @input="hideSnackBar()" color="#4CAF50">
      {{ snackBarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="hideSnackBar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <LogoutNotification
      :open.sync="openLogoutDialog"
      :endSessionTimer="endSessionTimer"
    />
  </v-app>
</template>

<script>
import { ref, onBeforeMount, computed, toRefs } from "@vue/composition-api";
import { useTitle } from "@/composables/title";
import { useLogin } from "@/composables/login";
import { useSnackBar, hideSnackBar } from "@/composables/snackbar";
import WifipassIcon from "@/components/Icones/wifipass-logo.vue";
import LogoutNotification from "@/components/General/LogoutNotification.vue";
import router from "@/router";
import { useHomePage } from "@/composables/home-page";
import GlobalSearchBar from "@/components/General/GlobalSearchBar.vue";
import global from "@/composables/global";
import CustomTabs from "@/components/General/AppBarTabs.vue";
import { useRoles } from "@/composables/roles";

export default {
  components: {
    WifipassIcon,
    LogoutNotification,
    GlobalSearchBar,
    CustomTabs,
  },
  setup(props, { root }) {
    /* Import des API */
    const {
      username,
      checkLoginOnLoad,
      setLogOutWatcher,
      resetLoginInfos,
      openLogoutDialog,
      endSessionTimer,
    } = useLogin();
    const { homepageData, getHomeData } = useHomePage();
    const { title, icon } = useTitle();
    const { snackBar, snackBarMessage } = useSnackBar();
    const { isAdmin } = useRoles();

    /* Cycle de vie */
    onBeforeMount(() => {
      getHomeData((apiResult) => {
        global.totalPortals = apiResult.nbPortal;
        global.totalGroups = apiResult.nbGroup;
        global.totalNas = apiResult.nbNas;
      });
      if (checkLoginOnLoad()) {
        setLogOutWatcher();
      } else {
        resetLoginInfos();
      }
    });

    /* Variables */
    const headerColor = config.VUE_APP_HEADER_COLOR;
    let drawer = ref(null);

    /* Computed */
    const titleIcon = computed(function () {
      let result = "";

      if (icon.value) {
        if (icon.value.indexOf("mdi") > -1) {
          result = icon.value;
        } else {
          result = `$${icon.value}`;
        }
      }

      return result;
    });
    const isMobile = computed(function () {
      return root.$vuetify.breakpoint.mobile;
    });

    /* Méthodes */
    const exit = function () {
      resetLoginInfos();
      router.push("/login");
    };

    return {
      exit,
      drawer,
      snackBar,
      snackBarMessage,
      hideSnackBar,
      title,
      username,
      headerColor,
      openLogoutDialog,
      endSessionTimer,
      titleIcon,
      ...toRefs(homepageData),
      isMobile,
      global,
      appVersion: config.APP_VERSION,
      isAdmin,
    };
  },
};
</script>
